'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidFolderOpen = function IoAndroidFolderOpen(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 11.3c1.8 0 3.4 1.5 3.4 3.3v14.5c0 1.8-1.6 3.4-3.4 3.4h-28.2c-1.8 0-3.4-1.6-3.4-3.4v-18.2c0-1.8 1.6-3.4 3.4-3.4h10.7l3.4 3.8h14.1z m0.9 17.8v-14.5c0-0.5-0.4-0.8-0.9-0.8h-29.1v15.3c0 0.5 0.4 0.9 0.9 0.9h28.2c0.5 0 0.9-0.4 0.9-0.9z' })
        )
    );
};

exports.default = IoAndroidFolderOpen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-folder-open.js
// module id = 1862
// module chunks = 0